import { useState } from "react";
import { SORTDROPDOWNICON, SORTDROPUPICON } from "../Utils/icons";
import { isEmptyArray } from "../Utils/util";
const ReactTable = ({ data, columns }) => {
  const [inputValues, setInputValues] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [sortList, setSortList] = useState([...data]);

  const handleInputChange = (event, accessor) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [accessor]: event.target.value,
    }));
  };

  const requestSort = (key) => {
    let direction = "";
    sortConfig.key === key && sortConfig.direction === "asc"
      ? (direction = "desc")
      : (direction = "asc");
    handleSort(key, direction);
    setSortConfig({ key, direction });
  };

  const handleSort = (key, direction) => {
    if (key && !isEmptyArray(data)) {
      const sorted = [...data].sort((a, b) => {
        if (a[key] === null) return 1;
        if (b[key] === null) return -1;
        if (a[key] === null && b[key] === null) return 0;
        return (
          a[key].toString().localeCompare(b[key].toString(), "en", {
            numeric: true,
          }) * (direction === "asc" ? 1 : -1)
        );
      });
      setSortList(sorted);
    }
  };

  const clickHandler = (column, row) => {
    if (column.clickHandler) {
      column.clickHandler(column, row);
    }
  };

  const getClassName = (column) => {
    if (column.alignment === "left") {
      return "left";
    } else if (column.alignment === "right") {
      return "right";
    } else if (column.alignment === "center") {
      return "center";
    } else {
      return "left";
    }
  };

  return (
    <table className="table">
      <thead>
        <tr>
          {columns.map((column, columnIndex) => (
            <th
              key={columnIndex}
              className="cell header-cell"
              onClick={() => column.sortable && requestSort(column.accessor)}
            >
              <div className="table-flex">
                {column.header}
                <span>
                  {sortConfig.key === column.accessor &&
                  sortConfig.direction === "asc" ? (
                    <SORTDROPDOWNICON />
                  ) : (
                    <SORTDROPUPICON />
                  )}
                </span>
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sortList.map((row, rowIndex) => (
          <tr key={rowIndex} className="">
            {columns.map((column, columnIndex) => (
              <td key={columnIndex} className={getClassName(column)}>
                {column.isInput ? (
                  <input
                    type="text"
                    value={inputValues[column.accessor] || ""}
                    onChange={(event) =>
                      handleInputChange(event, column.accessor)
                    }
                  />
                ) : null}
                {column.isHyperLink ? (
                  <div
                    className="hyperLink"
                    onClick={() => clickHandler(column, row)}
                  >
                    {row[column.accessor]}
                  </div>
                ) : null}
                {!column.isHyperLink && !column.isInput
                  ? row[column.accessor]
                  : null}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ReactTable;
